import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const UiDialogContent = (props) => {
  const { children, className, ...restProps } = props;
  return (
    <DialogContent
      className={classNames('ui-dialog-content', 'card-body', className)}
      {...restProps}
    >
      {children}
    </DialogContent>
  );
};

UiDialogContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default UiDialogContent;
